<template>
  <div class="step2-weflix">
    <p class="step2-context">
      Weflix — configure personalização e configurações da loja.
    </p>

    <div class="step2-accordions">
      <!-- Domínios -->
      <section class="step2-accordion" :class="{ 'is-open': f.isSectionOpen('domains') }">
        <div class="step2-accordion__bar">
          <button
            type="button"
            class="step2-accordion__toggle"
            :aria-expanded="f.isSectionOpen('domains')"
            @click="f.toggleSection('domains')"
          >
            <span class="step2-accordion__copy">
              <strong>Domínios</strong>
              <small>Domínio Weflix e domínios próprios</small>
            </span>
            <fa
              class="step2-accordion__chevron"
              :icon="f.isSectionOpen('domains') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
            />
          </button>
          <button
            v-if="f.showFillPreview"
            type="button"
            class="btnSave btnFillPreview btnFillSection"
            :disabled="!f.hasReady || f.fillingPreview"
            @click="f.fillPreviewData('domains')"
          >
            Preencher dados
          </button>
        </div>
        <div v-show="f.isSectionOpen('domains')" class="step2-accordion__body">
          <div class="row">
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Nome do Domínio Weflix</label></div>
                <div class="form-input">
                  <div class="domain-check">
                    <input
                      type="text"
                      class="form-control"
                      v-model="f.urlTemporary"
                      placeholder="Meu Domínio"
                      @keyup="f.createFullDomain()"
                    />
                    <span
                      v-if="f.hasValidDomain === true"
                      class="domain-check__status domain-check__status--ok"
                    >
                      <fa icon="fa-solid fa-circle-check" />
                    </span>
                    <span
                      v-else-if="f.hasValidDomain === false"
                      class="domain-check__status domain-check__status--error"
                    >
                      <fa icon="fa-solid fa-circle-xmark" />
                    </span>
                    <button type="button" class="btn_new" @click="f.validateDomain">Verificar</button>
                  </div>
                  <small>Apenas texto, sem espaços ou caracteres especiais.</small>
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Domínio final Weflix</label></div>
                <div class="form-input">
                  <input type="text" class="form-control" :value="f.url" disabled />
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Domínio primário</label></div>
                <div class="form-input">
                  <input type="text" class="form-control" v-model="f.url1" placeholder="https://www.seudominio.com.br" />
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Domínio secundário</label></div>
                <div class="form-input">
                  <input type="text" class="form-control" v-model="f.url2" placeholder="https://loja.seudominio.com.br" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Básico -->
      <section class="step2-accordion" :class="{ 'is-open': f.isSectionOpen('basic') }">
        <div class="step2-accordion__bar">
          <button
            type="button"
            class="step2-accordion__toggle"
            :aria-expanded="f.isSectionOpen('basic')"
            @click="f.toggleSection('basic')"
          >
            <span class="step2-accordion__copy">
              <strong>Básico</strong>
              <small>Identidade do site, cor, integrações e código</small>
            </span>
            <fa
              class="step2-accordion__chevron"
              :icon="f.isSectionOpen('basic') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
            />
          </button>
          <button
            v-if="f.showFillPreview"
            type="button"
            class="btnSave btnFillPreview btnFillSection"
            :disabled="!f.hasReady || f.fillingPreview"
            @click="f.fillPreviewData('basic')"
          >
            Preencher dados
          </button>
        </div>
        <div v-show="f.isSectionOpen('basic')" class="step2-accordion__body">
          <div class="row">
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Título do Site</label></div>
                <div class="form-input">
                  <input type="text" class="form-control" v-model="f.title" placeholder="Título do seu site" />
                </div>
              </div>
              <div class="form-group">
                <div class="form-label"><label>Descrição</label></div>
                <div class="form-input">
                  <textarea class="form-control textarea_input" v-model="f.description"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label"><label>Descrição Sobre</label></div>
                <div class="form-input">
                  <textarea class="form-control textarea_input" v-model="f.about"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label"><label>WhatsApp</label></div>
                <div class="form-input">
                  <input type="text" class="form-control" v-model="f.phoneSite" placeholder="(11) 99999-9999" />
                </div>
              </div>
              <div class="form-group">
                <div class="form-label"><label>E-mail do site</label></div>
                <div class="form-input">
                  <input type="email" class="form-control" v-model="f.emailSite" placeholder="contato@loja.com" />
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label">
                  <label>Logo</label>
                  <small>Insira uma imagem maior que 120x60 pixels</small>
                </div>
                <div class="form-file">
                  <div class="file-wrapper primary">
                    <img v-show="f.logoDisplay" :src="f.logoDisplay" alt="Logo" class="file-preview" />
                    <span class="thumbnail" v-show="!f.logoDisplay">
                      <fa icon="fa-solid fa-image" />
                      <span class="text">Clique para selecionar a imagem</span>
                    </span>
                    <LoaderImage :hasReady="f.loaderImage" />
                    <input class="form-control" type="file" accept=".png, .jpg, .jpeg, .webp" @change="f.updateFilePathLogo" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label>Favicon</label>
                  <small>Imagem do ícone na aba do navegador.</small>
                </div>
                <div class="form-file">
                  <div class="file-wrapper primary">
                    <img v-show="f.faviconDisplay" :src="f.faviconDisplay" alt="Favicon" class="file-preview" />
                    <span class="thumbnail" v-show="!f.faviconDisplay">
                      <fa icon="fa-solid fa-image" />
                      <span class="text">Clique para selecionar</span>
                    </span>
                    <input class="form-control" type="file" accept=".png, .jpg, .jpeg, .webp, .ico" @change="f.updateFilePathFavicon" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section-title">
            <div>
              <h4>Banner principal</h4>
              <p>Para maior qualidade, use uma imagem maior que 1980x768 pixels.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-form-inner col-12">
              <div class="form-group">
                <div class="form-file">
                  <div class="file-wrapper primary file-wrapper--banner">
                    <img
                      v-show="f.bannerDisplay"
                      :src="f.bannerDisplay"
                      alt="Banner principal"
                      class="file-preview"
                    />
                    <span class="thumbnail" v-show="!f.bannerDisplay">
                      <span class="text">Clique aqui para selecionar a imagem</span>
                    </span>
                    <LoaderImage :hasReady="f.loaderImage" />
                    <input
                      class="form-control"
                      type="file"
                      accept=".png, .jpg, .jpeg, .webp"
                      @change="f.updateFilePathBanner"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section-title section-title--fill">
            <div>
              <h4>Cor do template</h4>
              <p>Cor do template e identidade visual</p>
            </div>
            <button
              v-if="f.showFillPreview"
              type="button"
              class="btnSave btnFillPreview btnFillSection"
              :disabled="!f.hasReady || f.fillingPreview"
              @click="f.fillPreviewData('color')"
            >
              Preencher dados
            </button>
          </div>
          <div class="row">
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Cor do Template</label></div>
                <div class="form-input colors">
                  <div class="inputsColors">
                    <input type="color" :value="f.colorValue" @input="f.color = $event.target.value" />
                    <input
                      type="text"
                      class="form-control"
                      v-model="f.color"
                      placeholder="#ffffff"
                      @blur="f.color = f.normalizeHex(f.color)"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label"><label>Sugestões de Cores</label></div>
                <div class="wrap-suggested-colors">
                  <span
                    v-for="hex in f.suggestedColors"
                    :key="hex"
                    :style="{ backgroundColor: hex }"
                    @click="f.setColor(hex)"
                  ></span>
                </div>
              </div>
              <div class="step2-weflix__color-sample">
                <label>Exemplo:</label>
                <button type="button" :style="{ backgroundColor: f.colorValue }">Botão de Exemplo</button>
              </div>
            </div>
          </div>
          <div class="section-title section-title--fill">
            <div>
              <h4>Integrações</h4>
              <p>Pixels, analytics e RD Station</p>
            </div>
            <button
              v-if="f.showFillPreview"
              type="button"
              class="btnSave btnFillPreview btnFillSection"
              :disabled="!f.hasReady || f.fillingPreview"
              @click="f.fillPreviewData('integrations')"
            >
              Preencher dados
            </button>
          </div>
          <div class="row">
            <div
              v-for="field in f.integrationFields"
              :key="field.key"
              class="col-form-inner col-6 col-md-6"
            >
              <div class="form-group">
                <div class="form-label"><label>{{ field.label }}</label></div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    v-model="f.integrations[field.key]"
                    :placeholder="field.placeholder"
                  />
                  <small>{{ field.hint }}</small>
                </div>
              </div>
            </div>
            <div
              v-for="field in f.rdFields"
              :key="field.key"
              class="col-form-inner col-6 col-md-6"
            >
              <div class="form-group">
                <div class="form-label"><label>{{ field.label }}</label></div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    v-model="f.integrations[field.key]"
                    :placeholder="field.placeholder"
                  />
                  <small>{{ field.hint }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="section-title section-title--fill">
            <div>
              <h4>Avançado</h4>
              <p>CSS e JavaScript customizados</p>
            </div>
            <button
              v-if="f.showFillPreview"
              type="button"
              class="btnSave btnFillPreview btnFillSection"
              :disabled="!f.hasReady || f.fillingPreview"
              @click="f.fillPreviewData('advanced')"
            >
              Preencher dados
            </button>
          </div>
          <div class="row">
            <div class="col-form-inner col-12">
              <div class="form-group">
                <div class="form-label"><label>CSS</label></div>
                <div class="form-input">
                  <textarea class="form-control textarea_input step2-code" v-model="f.css" placeholder="<style>...</style>"></textarea>
                </div>
              </div>
            </div>
            <div class="col-form-inner col-12">
              <div class="form-group">
                <div class="form-label"><label>JavaScript</label></div>
                <div class="form-input">
                  <textarea class="form-control textarea_input step2-code" v-model="f.javascript" placeholder="<script>...</script>"></textarea>
                  <small class="warn">JS customizado pode afetar o funcionamento do site.</small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- Temas -->
      <section class="step2-accordion" :class="{ 'is-open': f.isSectionOpen('themes') }">
        <div class="step2-accordion__bar">
          <button
            type="button"
            class="step2-accordion__toggle"
            :aria-expanded="f.isSectionOpen('themes')"
            @click="f.toggleSection('themes')"
          >
            <span class="step2-accordion__copy">
              <strong>Temas</strong>
              <small>Netflix / Light e exibição do catálogo</small>
            </span>
            <fa
              class="step2-accordion__chevron"
              :icon="f.isSectionOpen('themes') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
            />
          </button>
          <button
            v-if="f.showFillPreview"
            type="button"
            class="btnSave btnFillPreview btnFillSection"
            :disabled="!f.hasReady || f.fillingPreview"
            @click="f.fillPreviewData('themes')"
          >
            Preencher dados
          </button>
        </div>
        <div v-show="f.isSectionOpen('themes')" class="step2-accordion__body">
          <div class="step2-weflix__themes">
            <button
              type="button"
              class="step2-weflix__theme-card"
              :class="{ active: Number(f.typeLayout) === 0 }"
              @click="f.typeLayout = 0"
            >
              <img src="@/assets/Weflix/theme2.png" alt="Tema Netflix" />
              <div>
                <strong>Netflix</strong>
                <p>Visual moderno e escuro com tons de preto e cinza.</p>
              </div>
            </button>
            <button
              type="button"
              class="step2-weflix__theme-card"
              :class="{ active: Number(f.typeLayout) === 1 }"
              @click="f.typeLayout = 1"
            >
              <img src="@/assets/Weflix/theme1.png" alt="Tema Light" />
              <div>
                <strong>Light</strong>
                <p>Design clean e minimalista com tons claros.</p>
              </div>
            </button>
          </div>

          <div class="section-title" style="margin-top: 1.25rem;">
            <h4>Configurações de Exibição</h4>
            <p>Defina como o conteúdo será mostrado</p>
          </div>
          <div class="row">
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Formato da Capa do Curso</label></div>
                <div class="form-input">
                  <select class="form-control" v-model="f.typeImageCoverCourse">
                    <option :value="1">Capa Horizontal (1920 × 200px)</option>
                    <option :value="2">Capa Vertical (240 × 440px)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Exibir títulos dos vídeos</label></div>
                <div class="form-input">
                  <select class="form-control" v-model="f.visibleTitleCourse">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Redes sociais -->
      <section class="step2-accordion" :class="{ 'is-open': f.isSectionOpen('social') }">
        <div class="step2-accordion__bar">
          <button
            type="button"
            class="step2-accordion__toggle"
            :aria-expanded="f.isSectionOpen('social')"
            @click="toggleSocial"
          >
            <span class="step2-accordion__copy">
              <strong>Redes sociais</strong>
              <small>Links exibidos no site</small>
            </span>
            <fa
              class="step2-accordion__chevron"
              :icon="f.isSectionOpen('social') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
            />
          </button>
          <button
            v-if="f.showFillPreview"
            type="button"
            class="btnSave btnFillPreview btnFillSection"
            :disabled="!f.hasReady || f.fillingPreview"
            @click="f.fillPreviewData('social')"
          >
            Preencher dados
          </button>
        </div>
        <div v-show="f.isSectionOpen('social')" class="step2-accordion__body">
          <div class="row">
            <div
              v-for="(name, index) in f.socialNames"
              :key="`weflix-social-${index}`"
              class="col-form-inner col-6 col-md-6"
            >
              <div class="step2-social-row">
                <div class="step2-social-row__head">
                  <strong>{{ name }}</strong>
                  <label class="step2-switch">
                    <input type="checkbox" v-model="f.socialEnabled[index]" />
                    <span class="step2-switch__track" aria-hidden="true"></span>
                    <span class="step2-switch__text">{{ f.socialEnabled[index] ? 'On' : 'Off' }}</span>
                  </label>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="f.socialLinks[index]"
                  :placeholder="f.socialPlaceholders[index]"
                  :disabled="!f.socialEnabled[index]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Geral -->
      <section class="step2-accordion" :class="{ 'is-open': f.isSectionOpen('general') }">
        <div class="step2-accordion__bar">
          <button
            type="button"
            class="step2-accordion__toggle"
            :aria-expanded="f.isSectionOpen('general')"
            @click="f.toggleSection('general')"
          >
            <span class="step2-accordion__copy">
              <strong>Geral</strong>
              <small>Carrinho e checkout da loja</small>
            </span>
            <fa
              class="step2-accordion__chevron"
              :icon="f.isSectionOpen('general') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
            />
          </button>
          <button
            v-if="f.showFillPreview"
            type="button"
            class="btnSave btnFillPreview btnFillSection"
            :disabled="!f.hasReady || f.fillingPreview"
            @click="f.fillPreviewData('general')"
          >
            Preencher dados
          </button>
        </div>
        <div v-show="f.isSectionOpen('general')" class="step2-accordion__body">
          <div class="step2-toggle-list">
            <div class="step2-toggle-row">
              <div class="step2-toggle-row__copy">
                <strong>Fechamento de carrinho</strong>
                <p>Quando ativo, o fluxo de compra exige fechamento do carrinho.</p>
              </div>
              <label class="step2-switch">
                <input type="checkbox" v-model="f.cartClosure" />
                <span class="step2-switch__track" aria-hidden="true"></span>
                <span class="step2-switch__text">{{ f.cartClosure ? 'Ativo' : 'Inativo' }}</span>
              </label>
            </div>
            <div class="step2-toggle-row">
              <div class="step2-toggle-row__copy">
                <strong>Exibir valor parcelado no checkout</strong>
                <p>Mostra estimativa de parcelas na tela de pagamento.</p>
              </div>
              <label class="step2-switch">
                <input type="checkbox" v-model="f.showInstallmentValue" />
                <span class="step2-switch__track" aria-hidden="true"></span>
                <span class="step2-switch__text">{{ f.showInstallmentValue ? 'Ativo' : 'Inativo' }}</span>
              </label>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import LoaderImage from '@/components/Weflix/LoaderImage.vue';

export default {
  name: 'CompanyStep2WeflixPanel',
  components: { LoaderImage },
  inject: ['step2Form'],
  computed: {
    f() {
      return this.step2Form;
    },
  },
  methods: {
    toggleSocial() {
      this.f.socialActive = true;
      this.f.toggleSection('social');
    },
  },
};
</script>

<style scoped>
.step2-accordions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.step2-accordion {
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.step2-accordion__bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-right: 1rem;
  background: #f8f9fc;
}

.step2-accordion.is-open .step2-accordion__bar {
  background: #f3f0ff;
  border-bottom: 1px solid #e8eaf0;
}

.step2-accordion__toggle {
  appearance: none;
  flex: 1;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.1rem;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background-color 150ms ease;
}

.step2-accordion.is-open .step2-accordion__toggle {
  background: transparent;
  border-bottom: 0;
}

.step2-accordion__bar :deep(.btnFillSection) {
  flex: 0 0 auto;
  min-width: 0;
  padding: 6px 12px;
  font-size: 0.8125rem;
  line-height: 1.2;
  box-shadow: none;
}

.step2-accordion__toggle:hover {
  background: #f0edfa;
}

.step2-accordion__toggle:focus-visible {
  outline: 2px solid #250891;
  outline-offset: -2px;
}

.step2-accordion__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.step2-accordion__copy strong {
  color: #191c24;
  font-size: 0.9375rem;
  font-weight: 700;
}

.step2-accordion__copy small {
  color: #697386;
  font-size: 0.78rem;
  line-height: 1.4;
}

.step2-accordion__chevron {
  color: #250891;
  flex-shrink: 0;
  width: 0.9rem;
  height: 0.9rem;
}

.step2-accordion__body {
  padding: 1.1rem 1.1rem 1.25rem;
}

.step2-toggle-list {
  display: flex;
  flex-direction: column;
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 0.25rem;
}

.step2-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.1rem;
  background: #fff;
  text-align: left;
}

.step2-toggle-row + .step2-toggle-row {
  border-top: 1px solid #eef0f4;
}

.step2-toggle-row__copy {
  min-width: 0;
  flex: 1 1 auto;
}

.step2-toggle-row__copy strong {
  display: block;
  color: #191c24;
  font-size: 0.875rem;
  font-weight: 600;
}

.step2-toggle-row__copy p {
  margin: 0.2rem 0 0;
  color: #697386;
  font-size: 0.78rem;
  line-height: 1.4;
}

.step2-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  user-select: none;
}

.step2-switch input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.step2-switch__track {
  position: relative;
  width: 2.5rem;
  height: 1.4rem;
  border-radius: 999px;
  background: #d5d9e2;
  transition: background-color 160ms ease;
  flex-shrink: 0;
}

.step2-switch__track::after {
  content: '';
  position: absolute;
  top: 0.15rem;
  left: 0.15rem;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 160ms ease;
}

.step2-switch input:checked + .step2-switch__track {
  background: #250891;
}

.step2-switch input:checked + .step2-switch__track::after {
  transform: translateX(1.1rem);
}

.step2-switch__text {
  min-width: 3.25rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #697386;
}

.step2-social-row {
  border: 1px solid #e8eaf0;
  border-radius: 10px;
  padding: 0.85rem;
  margin-bottom: 0.75rem;
  background: #fafbfe;
}

.step2-social-row__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.55rem;
}

.step2-social-row__head strong {
  font-size: 0.875rem;
  color: #191c24;
}

.step2-weflix__themes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.step2-weflix__theme-card {
  appearance: none;
  border: 2px solid #e8eaf0;
  border-radius: 12px;
  background: #fff;
  padding: 0.75rem;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  font: inherit;
  color: inherit;
}

.step2-weflix__theme-card img {
  width: 100%;
  max-height: 140px;
  object-fit: contain;
  object-position: center top;
  border-radius: 8px;
  display: block;
  background: #f6f7fb;
}

.step2-weflix__theme-card strong {
  display: block;
  margin-bottom: 0.2rem;
}

.step2-weflix__theme-card p {
  margin: 0;
  font-size: 0.8125rem;
  color: #697386;
}

.step2-weflix__theme-card.active {
  border-color: #250891;
  box-shadow: 0 0 0 1px #250891;
}

.step2-weflix__color-sample {
  margin-top: 1rem;
}

.step2-weflix__color-sample label {
  display: block;
  margin-bottom: 0.5rem;
}

.step2-weflix__color-sample button {
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 768px) {
  .step2-weflix__themes {
    grid-template-columns: 1fr;
  }
}
</style>
